import React from "react";
import { Pagination } from "react-bootstrap";

const PaginationComponent = ({
  currentPage,
  totalPages,
  onPageChange,
  data,
}) => {
  const pageItems = [];

  const rangeStart = Math.max(1, currentPage - 2);
  const rangeEnd = Math.min(totalPages, rangeStart + 4);
  if (data >= 15) {
    for (let i = rangeStart; i <= rangeEnd; i++) {
      pageItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => onPageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
  }

  return (
    <Pagination className="justify-content-center">
      {currentPage > 1 && (
        <Pagination.Prev
          size="lg"
          style={{ width: "50px" }}
          onClick={() => onPageChange(currentPage - 1)}
        />
      )}
      {pageItems}
      {currentPage < totalPages ? (
        <Pagination.Next
          style={{ width: "50px" }}
          disabled={data < 15}
          onClick={() => onPageChange(currentPage + 1)}
        />
      ) : null}
    </Pagination>
  );
};

export default React.memo(PaginationComponent);
